export default __webpack_public_path__ + "static/media/floor2.c8d35024.png";